import React from 'react'

interface Props {
  style?: React.CSSProperties
}

export const DoubleChevronLeftVector = ({
  style,
}: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 6.3499998 6.3499998"
    version="1.1"
    style={style}
  >
    <defs
    id="defs2" />
    <g
      id="layer1"
      transform="translate(0,-290.65)"
    >
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.529167,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="M 3.1750001,295.4125 1.5875,293.825 3.1750001,292.2375"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.529167,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="M 4.7625,295.4125 3.1749999,293.825 4.7625,292.2375"
      />
    </g>
  </svg>
)
